import React from "react"
import Underline from "../Underline/underline"

import classes from "./title.module.scss"

const Title = props => {
  let titleElement = null
  switch (props.type) {
    case "primary":
      titleElement = <h2>{props.children}</h2>
      break
    case "secondary":
      titleElement = <h4>{props.children}</h4>
      break
    default:
      break
  }
  return (
    <div className={classes.Title}>
      {titleElement}
      <Underline size={props.underline} />
    </div>
  )
}

export default Title
